import styled from 'styled-components';

export const Card = styled.div`
  margin-left: auto;
  margin-right: auto;
  padding: 10px;
  width: 25%;
  min-width: 300px;
`;